module.exports = __webpack_public_path__ + "img/no-policy.f4b5d598.png";